import React, { useState } from 'react';
import { useRecordContext, useRefresh, useTranslate } from 'react-admin';
import { Button, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { TabletMac } from '@material-ui/icons';

import { FF_SCOREKEEPING_APP } from '@hisports/common/featureFlags';
import { KEEPER_POSITIONS, OFFICIAL_POSITIONS } from '@hisports/scoresheet/src/constants';

import AlertDialog from '../../../../common/dialogs/AlertDialog';
import { isAuthorized } from '../../../../common/Authorize';
import { useFlag } from '../../../../http';

import { ApprovalDialog } from '../ApprovalModal';

const useStyles = makeStyles(theme => ({
  approval: {
    marginLeft: theme.spacing(1),
  },
}))

const ApprovalButton = ({ isMissingIncidents, ...props }) => {
  const translate = useTranslate();
  const [modalOpen, setModalOpen] = useState(false);
  const [alert, setAlert] = useState({ isOpen: false })
  const refresh = useRefresh()

  const handleClick = () => {
    if (!isMissingIncidents) {
      setModalOpen(true)
    } else {
      setAlert({
        title: translate('resources.scoresheets.alerts.missingIncidents.title'),
        message: translate('resources.scoresheets.alerts.missingIncidents.message'),
        reject: 'ra.action.ok',
        isOpen: true,
        onClose: () => {
          setAlert(alert => ({ ...alert, isOpen: false }));
          refresh()
        }
      })
    }
  }

  return <>
    <Button color="primary" variant="contained" size="small" onClick={() => handleClick()} {...props}>{translate('resources.scoresheets.labels.complete')}</Button>
    {modalOpen && <ApprovalDialog open={modalOpen} setModalOpen={setModalOpen} />}
    <AlertDialog {...alert} />
  </>
}

const ScorekeepingButton = ({ gameId, officials, ...props }) => {
  const translate = useTranslate();
  const assignedOfficials = officials?.assignments?.filter(official => ['assigned', 'confirmed'].includes(official.status));
  const hasRequiredOfficials = assignedOfficials?.some(official => KEEPER_POSITIONS.includes(official.position)) && assignedOfficials?.some(official => OFFICIAL_POSITIONS.includes(official.position));
  const scorekeepingUrl = hasRequiredOfficials ? `/scoresheets/${gameId}/scoresheet` : `/scoresheets/${gameId}/pregame`;

  return <Button startIcon={<TabletMac />} color="primary" size="small" href={scorekeepingUrl} {...props}>
    {translate('resources.games.labels.scorekeeping')}
  </Button>
}

export const ApproveAlert = ({ canApprove, status, ...props }) => {
  const translate = useTranslate();
  const game = useRecordContext();
  const classes = useStyles();
  const isEnabled = useFlag();

  const { officials, scorekeeping = false, scoringMode = 'Detailed', penaltyMode = 'Detailed' } = status || {};
  const showButton = canApprove || isAuthorized(game, 'scoresheets', 'full');
  const showScorekeeping = scorekeeping && (scoringMode === 'Detailed' && penaltyMode === 'Detailed') && isEnabled(FF_SCOREKEEPING_APP) && isAuthorized(game, 'scoresheets', 'full');

  return <Alert severity="info" action={[
    showScorekeeping && <ScorekeepingButton gameId={game?.id} officials={officials} {...props} />,
    showButton && <ApprovalButton className={classes.approval} {...props} />
  ]}>
    {translate('resources.scoresheets.alerts.approve')}
  </Alert>
}
